import { render } from "./FormLogo.vue?vue&type=template&id=38d04b8f"
import script from "./FormLogo.vue?vue&type=script&lang=js"
export * from "./FormLogo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projekty\\Adaste\\vue-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__